import {
  Dialog,
  DialogContent,
  Typography,
  List,
  Grid,
  DialogActions,
  Button,
  Divider,
} from '@mui/material';
import React from 'react';
import { getDayMonth, getTime, GroupedBookings, getCanceledTime } from '../utils';
import { BookingsModalDialogTitle, BookingsModalListItemText } from './CanceledBookingModal.styled';

export interface CanceledBookingModalProps {
  selectedGroups: GroupedBookings[];
  isOpen: boolean;
  handleCloseCanceledBookingDialog: () => void;
}

const CanceledBookingModal = ({
  selectedGroups,
  isOpen,
  handleCloseCanceledBookingDialog,
}: CanceledBookingModalProps) => {
  return (
    <Dialog
      open={isOpen}
      onClose={handleCloseCanceledBookingDialog}
      sx={{ '.MuiPaper-root': { margin: 2, flexGrow: 1 } }}
    >
      <BookingsModalDialogTitle sx={{ height: '6rem' }}>
        Информация об отмененном бронировании
      </BookingsModalDialogTitle>

      <DialogContent sx={{ padding: '0 10px' }}>
        <List>
          {selectedGroups.map((block, index) => (
            <React.Fragment key={block.id}>
              {block?.bookings?.map((booking) => (
                <Grid
                  container
                  key={booking.id}
                  sx={{ alignItems: 'center', cursor: 'pointer', paddingTop: 3 }}
                >
                  <Grid
                    item
                    xs={6}
                  >
                    <Typography sx={{ fontSize: 16 }}>{`Забронировано`}</Typography>
                  </Grid>

                  <Grid
                    item
                    xs={6}
                  >
                    <Typography sx={{ fontSize: 16 }}>{`Время отмены`}</Typography>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                  >
                    <BookingsModalListItemText
                      primary={`${getDayMonth(booking.day.replace(/"/g, ''))} `}
                      secondary={`${getTime(booking.start_time)} - ${getTime(booking.end_time)}`}
                    />
                    <Divider sx={{ mb: 1 }} />
                  </Grid>

                  <Grid
                    item
                    xs={6}
                  >
                    <BookingsModalListItemText
                      primary={`${getDayMonth(booking.cancel_date)} `}
                      secondary={
                        booking.cancel_date ? `${getCanceledTime(booking.cancel_date)}` : ''
                      }
                    />
                    <Divider sx={{ mb: 1 }} />
                  </Grid>
                </Grid>
              ))}
            </React.Fragment>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleCloseCanceledBookingDialog}
          color='primary'
          sx={{ padding: '10px 30px' }}
        >
          Назад
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CanceledBookingModal;
